/* global THREE */
import aframe from "aframe";

aframe.registerComponent("face-camera", {
  tick: (() => {
    const v1 = new THREE.Vector3();

    return function(t, dt) {
      const camera = this.el.sceneEl.camera;

      const lookAtPos = camera.getWorldPosition(v1);
      if (this.el.object3D.parent) {
        this.el.object3D.parent.updateMatrixWorld();
        this.el.object3D.parent.worldToLocal(lookAtPos);
      }
      this.el.object3D.lookAt(lookAtPos);
    };
  })()
});
